import { BASE_URL } from 'config';
// src/layouts/users/data/usersTableData.js
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDBadge from "components/MDBadge";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
import { use, useState } from "react";
import IconButton from "@mui/material/IconButton";
import axios from "axios";
import Swal from "sweetalert2";
import { Person as PersonIcon } from "@mui/icons-material"; // أضف هذا الاستيراد
import { Box } from "@mui/material";
const CustomSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: theme.palette.success.main,
    "&:hover": {
      backgroundColor: theme.palette.success.light,
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: theme.palette.success.main,
  },
}));
export default function CurrencyTableData(users, handleEditClick, fetchUsers) {
  const [isActive, setIsActive] = useState(true);

  const handleSwitch = () => {
    setIsActive(!isActive);
  };
  const editFunction = (user) => {
    console.log(user);
  };
  const handleDeletion = async (user) => {
    // التحقق من الصلاحيات أولًا
    if (user.type === "administrator") {
      Swal.fire({
        icon: "error",
        title: "غير مسموح!",
        text: "صلاحيات الحذف مقصورة على المشرفين",
        confirmButtonText: "حسنًا",
        customClass: {
          confirmButton: "btn btn-danger",
        },
      });
      return;
    }

    // رسالة تأكيد احترافية
    const result = await Swal.fire({
      title: "هل أنت متأكد؟",
      text: `سيتم حذف التصنيف "${user.name}" بشكل دائم!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d32f2f",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "نعم، احذف!",
      cancelButtonText: "إلغاء",
      buttonsStyling: true,
      reverseButtons: true,
      focusCancel: true,
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const token = localStorage.getItem("user-token");
          const response = await axios.get(
            `${BASE_URL}/administrator/currencies/delete/${user.id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          return response.data;
        } catch (error) {
          Swal.showValidationMessage(
            `فشل الحذف: ${error.response?.data?.message || error.message}`
          );
          return false;
        }
      },
    });

    // معالجة النتيجة
    if (result.isConfirmed) {
      if (result.value?.status) {
        Swal.fire({
          icon: "success",
          title: "تم الحذف!",
          text: "تم حذف التصنيف بنجاح",
        });
        fetchUsers();
      } else {
        Swal.fire({
          title: "فشل الحذف!",
          text: result.value?.message || "حدث خطأ غير متوقع",
          icon: "error",
        });
      }
    }
  };
  const handleActivation = async (user, isActive) => {
    if (user.type == "administrator") {
      Swal.fire({
        icon: "error",
        title: "فشل تحديث حالة التصنيف",
        text: "ليس لديك صلاحية تعديل حالة المسؤول",
      });
      return;
    }
    try {
      const token = localStorage.getItem("user-token");
      const response = await axios.get(
        `${BASE_URL}/administrator/currencies/active/${user.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response);
      if (response.data.status) {
        Swal.fire({
          icon: "success",
          title: "تم التحديث!",
          text: "تم تغيير حالة العملة بنجاح",
        });
        // قم بتحديث الحالة المحلية إذا لزم الأمر
        fetchUsers(); // إعادة جلب البيانات من السيرفر
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "فشل التحديث!",
        text: error.response?.data?.message || "حدث خطأ أثناء التحديث",
      });
    }
  };
  const Author = ({ name, email, image }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
      </MDBox>
    </MDBox>
  );
  const Status = ({ isActive }) => (
    <MDBox ml={-1}>
      <MDBadge
        badgeContent={isActive ? "مفعل" : "غير مفعل"}
        color={isActive ? "success" : "dark"}
        variant="gradient"
        sx="larg"
      />
    </MDBox>
  );

  return {
    columns: [
      { Header: "الاسم", accessor: "author", width: "30%", align: "left" },
      { Header: "تفاصيل العملة", accessor: "info", align: "left" },
      { Header: "الحالة", accessor: "status", align: "center" },
      { Header: "الإجراءات", accessor: "action", align: "center" },
    ],

    rows: users.map((user) => ({
      author: <Author name={user.name} />,
      info: (
        <Box>
          <MDTypography variant="caption" color="text" fontWeight="medium" display="block">
            كود العملة: {user.code ? user.code : "---"}
          </MDTypography>
          <MDTypography variant="caption" color="text" fontWeight="medium" display="block">
            رمز العملة: {user.symbol ? user.symbol : "---"}
          </MDTypography>
          <MDTypography variant="caption" color="text" fontWeight="medium" display="block">
            عامل الصرف: {user.exchange_rate ? user.exchange_rate : "---"}
          </MDTypography>
        </Box>
      ),
      status: <Status isActive={user.is_active} />,
      action: (
        <MDBox
          display="flex"
          alignItems="center"
          gap={1}
          p={1}
          borderRadius="lg"
          bgcolor="background.paper"
          boxShadow={1}
        >
          <CustomSwitch
            checked={Boolean(user.is_active)}
            onChange={(e) => handleActivation(user, e.target.checked)}
            color="default"
          />

          <IconButton
            aria-label="edit"
            sx={{
              color: "info.main",
              "&:hover": {
                transform: "scale(1.1)",
                transition: "transform 0.2s",
              },
            }}
            onClick={() => handleEditClick(user)}
          >
            <EditIcon fontSize="medium" />
          </IconButton>

          <IconButton
            aria-label="delete"
            sx={{
              color: "error.main",
              "&:hover": {
                transform: "scale(1.1)",
                transition: "transform 0.2s",
              },
            }}
            onClick={() => handleDeletion(user)}
          >
            <DeleteIcon fontSize="medium" />
          </IconButton>
        </MDBox>
      ),
    })),
  };
}
